import { filter } from 'lodash';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  Card,
  Table,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Button,
  Typography,
  TableContainer,
  TablePagination,
  IconButton
} from '@material-ui/core';
import VisibilityIcon from '@material-ui/icons/Visibility';
import ThumbUpAltIcon from '@material-ui/icons/ThumbUpAlt';
import ThumbDownAltIcon from '@material-ui/icons/ThumbDownAlt';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import Scrollbar from '../Scrollbar';
import SearchNotFound from '../SearchNotFound';
import { ClientListHead } from '../_dashboard/clients';
// import { CircularIndeterminate } from '../CircularIndeterminate';
// import ProductListToolbar from './ProductListToolbar';
import { useEmployerContext } from '../../context/employer_context';
import { baseUrl } from '../../utils/constants';

const TABLE_HEAD = [
  { id: 'name', label: 'Name', alignRight: false },
  { id: 'description', label: 'Description', alignRight: false },
  { id: 'paymentFrequencyProduct', label: 'Frequency', alignRight: false },
  { id: 'productState', label: 'State', alignRight: false },
  { id: '' }
];

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(array, (_user) => _user.name.toLowerCase().indexOf(query.toLowerCase()) !== -1);
  }
  return stabilizedThis.map((el) => el[0]);
}

export default function EmployerList() {
  const { getEmployerView, setEmployerRefId } = useEmployerContext();
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [employerList, setEmployerList] = useState([]);
  const [orderBy, setOrderBy] = useState('name');
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(8);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    populateEmployerList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const TABLE_HEAD = [
    { id: 'name', label: 'Employer Name', alignRight: false },
    { id: 'registrationNumber', label: 'Reg. Number', alignRight: false },
    { id: 'employerState', label: 'Active', alignRight: false },
    { id: '' }
  ];

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = employerList.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };

  const handleEmployerView = (e) => {
    setEmployerRefId(e.row.employerRefId);
    getEmployerView(e.row.employerRefId);
    openNew();
  };

  const populateEmployerList = async () => {
    fetch(`${baseUrl}/api/setting/getallemployerslist`)
      .then((res) => res.json())
      .then(
        (result) => {
          setEmployerList(result.employers);
        },
        (error) => {
          alert('failed');
        }
      );
  };

  const handleNewEmployer = () => {
    console.log('entered here for employer');
    openNew();
  };

  const openNew = (e) => {
    navigate('/dashboard/editemployer');
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - employerList.length) : 0;

  const filteredUsers = applySortFilter(employerList, getComparator(order, orderBy), filterName);

  const isUserNotFound = filteredUsers.length === 0;

  // if (loading) return <CircularIndeterminate />;

  return (
    <Container>
      <Typography variant="h6" gutterBottom>
        Employers...
      </Typography>
      <Button
        variant="outlined"
        startIcon={<AddCircleOutlineIcon />}
        onClick={() => handleNewEmployer()}
      >
        Add New
      </Button>
      <Card>
        {/* <ProductListToolbar
          numSelected={selected.length}
          filterName={filterName}
          onFilterName={handleFilterByName}
        /> */}

        <Scrollbar>
          <TableContainer sx={{ minWidth: 800 }}>
            <Table>
              <ClientListHead
                order={order}
                orderBy={orderBy}
                headLabel={TABLE_HEAD}
                rowCount={employerList.length}
                numSelected={selected.length}
                onRequestSort={handleRequestSort}
                // onSelectAllClick={handleSelectAllClick}
              />
              <TableBody>
                {filteredUsers
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row) => {
                    const { employerRefId, name, registrationNumber, employerState } = row;
                    const isItemSelected = selected.indexOf(name) !== -1;

                    return (
                      <TableRow
                        hover
                        key={employerRefId}
                        tabIndex={-1}
                        role="checkbox"
                        selected={isItemSelected}
                        aria-checked={isItemSelected}
                      >
                        <TableCell padding="checkbox" />
                        <TableCell align="left">{name}</TableCell>
                        <TableCell align="left">{registrationNumber}</TableCell>
                        <TableCell align="left">{employerState ? 'Yes' : 'No'}</TableCell>
                        <TableCell align="right">
                          <IconButton onClick={() => handleEmployerView({ employerRefId })}>
                            <ThumbUpAltIcon sx={{ color: '#76ff03' }} />
                          </IconButton>
                          <IconButton>
                            <ThumbDownAltIcon sx={{ color: '#f44336' }} />
                          </IconButton>
                          <IconButton onClick={() => handleEmployerView({ row })}>
                            <VisibilityIcon sx={{ color: '#03a9f4' }} />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                {emptyRows > 0 && (
                  <TableRow style={{ height: 53 * emptyRows }}>
                    <TableCell colSpan={6} />
                  </TableRow>
                )}
              </TableBody>
              {isUserNotFound && (
                <TableBody>
                  <TableRow>
                    <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                      <SearchNotFound searchQuery={filterName} />
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}
            </Table>
          </TableContainer>
        </Scrollbar>

        <TablePagination
          rowsPerPageOptions={[8, 16, 24]}
          component="div"
          count={employerList.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Card>
    </Container>
  );
}
